import { Banner, Icon, Text } from "@portal/components/primitives";
import type { ReactNode } from "react";

export const WetSignatureDisclosureCard = ({ children }: { children?: ReactNode }) => {
	return (
		<Banner tone="info">
			<Banner.Leading>
				<Icon type="information-circle" size="medium" className="text-brand-accent" />
			</Banner.Leading>
			<Banner.Content className={children ? "flex flex-col gap-4" : undefined}>
				<Text type="body" color="primary">
					By selecting "Wet Signatures", you are responsible for collecting signatures from
					indemnitors, uploading a scanned copy of the signed indemnity agreement, and mailing the
					hard copy of the signed indemnity agreement to inRev
				</Text>
				{children}
			</Banner.Content>
		</Banner>
	);
};
